import type {ActionMenuItem} from '@Components/action-menu/action-menu.types';

export enum EventWizardCoverMenuSectionId {
  EDIT = 'edit',
  SOURCES = 'sources',
  REMOVE = 'remove',
}

/** One group of rows in the cover menu. Groups are split by a divider; a group with no items is left out. */
export interface EventWizardCoverMenuSection {
  id: EventWizardCoverMenuSectionId;
  header: string | null;
  items: ActionMenuItem[];
}

export interface EventWizardCoverMenuProps {
  sections: EventWizardCoverMenuSection[];
  isMobile: boolean;
}
